module.exports = __webpack_public_path__ + "static/media/livecoding480.20d1866a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/livecoding480.gif
// module id = 250
// module chunks = 0